<template>
  <div class=""></div>
</template>
<script>
export default {
  data() {
    return {}
  },
  mounted() {
    let item = this.$route.params.ItemsParams;
    if (this.$route.params.NextPage == 'Ticket') {
      this.$router.push({
        name: 'ChatRoom',
        params: {
          chatRoomId: item.TblChatRoomId,
          ticketManagerTblUserId: item.TblUserId,
          ticketId: item.Id,
          tblComboIdTicketStatus: item.TblComboGrpId41,
          departmentId: item.TblDepartmentId,
          customerName: item.CustomerName,
          customerCode: item.CustomerCode,
          tblCustomerId: item.TblCustomerId,
          tblComboGrpId42: item.TblComboGrpId42,
          tblComboGrpId45: item.TblComboGrpId45,
        },
      })
    }
    else if(this.$route.params.NextPage == 'DetailCustomer'){
        // this.$router.push({ name: 'DetailCustomer', params: { tblCustomerId: item } })
        this.$FindeCustomerById('DetailCustomer',item,false,null)
    }
  },
}
</script>
<style scoped></style>
